// Почему приглашение в первый обычный сетевой матч показывается сейчас —
// уровень события показа (page:OnlineMatchPromoModal:mount:<reason>)
export const ONLINE_MATCH_PROMO_REASONS = {
  // Первый показ на устройстве: бой с ботами уже сыгран
  FIRST: 'first',
  // Повторный: сетевого матча так и нет
  REMINDER: 'reminder',
};

/**
 * Показывать ли приглашение в первый обычный сетевой матч
 * (OnlineMatchPromoModal) и по какой причине; null — не показывать.
 *
 * Вторая ступень воронки новичка: зовем того, кто уже провел хотя бы одну
 * локальную партию против ботов (первая ступень — см.
 * resolveBotMatchPromoReason), но ни одного сетевого матча не сыграл.
 * Рейтинговые матчи входят в сетевые, поэтому игроку с рейтинговым матчем
 * приглашение не покажется — ему адресована следующая ступень
 * (resolveRankedMatchPromoReason).
 *
 * Прохождение обучения не требуется: партию против ботов можно сыграть и без
 * него, а сыгранный бой — признак посильнее пройденных глав.
 *
 * Оба счетчика приходят из профиля; null — «сервер не прислал» (гость, старая
 * сборка), и тогда молчим: без точного знания звать в «первый» матч нельзя.
 * Показ не чаще раза в сутки (isDue); первый показ наступает сразу, как
 * условие выполнилось, — счетчик локальных партий после боя двигается
 * локально (см. incrementLocalGamesPlayed), и приглашение ждет игрока уже
 * при возвращении в меню.
 *
 * @param {Object} params
 * @param {number|null} params.localGamesPlayed - сыгранные локальные партии
 * @param {number|null} params.onlineGamesPlayed - сыгранные сетевые матчи (все)
 * @param {boolean} params.isDue - суточная пауза с прошлого показа прошла
 * @param {boolean} params.isEverShown - показывали ли уже на этом устройстве
 * @returns {string|null} причина из ONLINE_MATCH_PROMO_REASONS или null
 */
export const resolveOnlineMatchPromoReason = ({
  localGamesPlayed,
  onlineGamesPlayed,
  isDue,
  isEverShown,
}) => {
  if (!(localGamesPlayed > 0) || onlineGamesPlayed !== 0 || !isDue) {
    return null;
  }
  return isEverShown ? ONLINE_MATCH_PROMO_REASONS.REMINDER : ONLINE_MATCH_PROMO_REASONS.FIRST;
};
